"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterBarActiveFilterFactory = exports.filterBarSectionFactory = exports.filterBarStateFactory = exports.filterBarSectionFilterFactory = void 0;
var filterBar_1 = require("../constants/filterBar");
/** **********************
 * FACTORIES
 *********************** */
var filterBarSectionFilterFactory = function (sections) {
    var stateSections = {};
    sections.forEach(function (section) {
        if (section.type === filterBar_1.FILTER_BAR_SECTION_TYPE.NO_FILTERS)
            return;
        stateSections[section.sectionId] = section.currentFilters || [];
    });
    return stateSections;
};
exports.filterBarSectionFilterFactory = filterBarSectionFilterFactory;
var filterBarStateFactory = function (config) {
    var _a;
    return (_a = {},
        _a[config.filterId] = __assign({}, (0, exports.filterBarSectionFilterFactory)(config.sections)),
        _a);
};
exports.filterBarStateFactory = filterBarStateFactory;
var filterBarSectionFactory = function (config) { return (__assign(__assign({}, config), { currentFilters: config.currentFilters || Array(0), items: config.items || Array(0), isCollapsed: config.isCollapsed, isCollapsible: config.isCollapsible !== undefined ? config.isCollapsible : true, isVisible: config.isVisible !== undefined ? config.isVisible : true, showClearAll: config.showClearAll !== undefined ? config.showClearAll : true })); };
exports.filterBarSectionFactory = filterBarSectionFactory;
var filterBarActiveFilterFactory = function (filterId, sectionId, value) { return ({
    filterId: filterId,
    sectionId: sectionId,
    value: value,
}); };
exports.filterBarActiveFilterFactory = filterBarActiveFilterFactory;
